export default function DiamondsBottom() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1365 1408">
      <rect
        width="230"
        height="230"
        x="883.884"
        y="180.312"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 883.884 180.312)"
      />
      <rect
        width="230"
        height="230"
        x="1064.2"
        y="360.624"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 1064.2 360.624)"
      />
      <rect
        width="230"
        height="230"
        x="523.259"
        y="180.312"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 523.259 180.312)"
      />
      <rect
        width="230"
        height="230"
        x="703.571"
        y="360.624"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 703.571 360.624)"
      />
      <rect
        width="230"
        height="230"
        x="883.884"
        y="540.937"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 883.884 540.937)"
      />
      <rect
        width="230"
        height="230"
        x="1064.2"
        y="721.249"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 1064.2 721.249)"
      />
      <rect
        width="230"
        height="230"
        x="342.947"
        y="360.624"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 342.947 360.624)"
      />
      <rect
        width="230"
        height="230"
        x="523.259"
        y="540.937"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 523.259 540.937)"
      />
      <rect
        width="230"
        height="230"
        x="703.571"
        y="721.249"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 703.571 721.249)"
      />
      <rect
        width="230"
        height="230"
        x="883.883"
        y="901.561"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 883.883 901.561)"
      />
      <rect
        width="230"
        height="230"
        x="342.947"
        y="721.249"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 342.947 721.249)"
      />
      <rect
        width="230"
        height="230"
        x="523.259"
        y="901.561"
        fill="#E7EEFB"
        rx="20"
        transform="rotate(45 523.259 901.561)"
      />
    </svg>
  )
}
